import ChecklistNavigationComponent, {
  ChecklistNavigationComponentProps,
} from './ChecklistNavigationComponent';

export default ChecklistNavigationComponent;

export type { ChecklistNavigationComponentProps };
